"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FALSY_VALUES = void 0;
var FALSY_VALUES = [false, 0, null, undefined, 'false', '0', 'null', 'undefined'];
exports.FALSY_VALUES = FALSY_VALUES;